import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly quicklinks?: ReadonlyArray<{
        url?: string;
        title?: string;
    }>;
};

export const QuickLinks: FC<Props> = ({ quicklinks }) => {
    const { t } = useTranslation();

    if (!quicklinks || quicklinks.length === 0) {
        return null;
    }

    return (
        <div className="quicklinks">
            <h2>{t('quickLinks')}</h2>
            <ul>
                {quicklinks.map((link, i) => {
                    return (
                        <li key={i}>
                            <Link to={link.url!}>{link.title}</Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
